module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"change_url":"Change url"},"id":{"change_url":"Ubah URL"}}')
  delete Component.options._Ctor
}
